import { render, staticRenderFns } from "./SessionDetails.vue?vue&type=template&id=07059d86&"
import script from "./SessionDetails.vue?vue&type=script&lang=js&"
export * from "./SessionDetails.vue?vue&type=script&lang=js&"
import style0 from "./SessionDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/zp_frontend_vuejs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07059d86')) {
      api.createRecord('07059d86', component.options)
    } else {
      api.reload('07059d86', component.options)
    }
    module.hot.accept("./SessionDetails.vue?vue&type=template&id=07059d86&", function () {
      api.rerender('07059d86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SessionDetails.vue"
export default component.exports